var _path, _path2, _path3, _ellipse, _path4, _ellipse2, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackyardMachine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 25H29V29H26V28H21V29H18V32H29V32H30V25Z",
    fill: "#575656"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7727 27.4437V29.7381H22V28L18.7727 24.7056L23.303 10.2684L25.3939 9.12338L27.684 11.6126V12.2597H30.2229L30.9697 11.6126V6.58442H25.842L25.3939 7.72944L23.6515 6.0368L1 3C2.2314 3.83417 1.97903 5.0183 1.76366 6.02883L1.76196 6.0368L20.8139 8.52597L21.6104 9.12338L16.881 23.3117H16.1342L18.7727 27.4437Z",
    fill: "#575656"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3442 36.4545V35.1602L18.3723 29.5V31.9892L10.3442 37V36.4545Z",
    fill: "#575656"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5433,
    cy: 37.1515,
    rx: 1.54329,
    ry: 0.348485,
    fill: "#575656"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0281 36.4545V35.1602L30 29.5V31.9892L38.0281 37V36.4545Z",
    fill: "#575656"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.54329,
    cy: 0.348485,
    rx: 1.54329,
    ry: 0.348485,
    transform: "matrix(-1 0 0 1 39.3723 36.803)",
    fill: "#575656"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 34.5C18 33.6716 18.6716 33 19.5 33H28.5C29.3284 33 30 33.6716 30 34.5C30 35.3284 29.3284 36 28.5 36H19.5C18.6716 36 18 35.3284 18 34.5ZM20 34.5C20 34.7761 19.7761 35 19.5 35C19.2239 35 19 34.7761 19 34.5C19 34.2239 19.2239 34 19.5 34C19.7761 34 20 34.2239 20 34.5ZM28.5 35C28.7761 35 29 34.7761 29 34.5C29 34.2239 28.7761 34 28.5 34C28.2239 34 28 34.2239 28 34.5C28 34.7761 28.2239 35 28.5 35Z",
    fill: "#575656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackyardMachine);
export default __webpack_public_path__ + "static/media/BACKYARD_MACHINE.a02c1e5538626db4a1aebff5729b2166.svg";
export { ForwardRef as ReactComponent };